// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__GkqY8","footer-column":"Footer_footer-column__i-ywI","category-headings":"Footer_category-headings__IkqSP"};